export const browserStorageKeys = {
  token: 'token',
}
